module.exports = __webpack_public_path__ + "img/x-gray-24.ee3e562b.svg";